import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

const noop = () => {};
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputFieldComponent),
  multi: true,
};

@Component({
    selector: 'gbc-input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    imports: [
    NgClass,
    FormsModule,
    TranslateModule
],
})
export class InputFieldComponent {
  constructor() {}
  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v === this.innerValue) {
      return;
    }

    this.innerValue = v;
    this.onChangeCallback(v);
  }
  @Input() max: number;
  @Input() min: number;
  @Input() step: number;
  @Input() maxlength: number;
  @Input() placeholderTranslationString: string;
  @Input() inputType = 'text';
  @Input() valid = true;
  @Input() errorDescriptionTranslationString: string;
  @Input() errorDescriptionData: { [k: string]: string } = {};
  @Input() formControlName: string;
  @Input() name: string;
  @Input() unit: string;

  @Output() fieldKeyupEvent = new EventEmitter<string>();

  disabled = false;

  // NgModel
  innerValue: any;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  onKey(value: string) {
    this.fieldKeyupEvent.emit(value);
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value === this.innerValue) {
      return;
    }
    if (this.inputType === 'number') {
      this.innerValue = Number.parseFloat(value);
    } else {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: (_: number | null) => void): void {
    this.onChangeCallback = (value) => {
      if (this.inputType === 'number') {
        fn(value === '' ? null : Number.parseFloat(value));
      } else {
        fn(value);
      }
    };
  }
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
